import { Check, House, Rocket, Trophy, BadgePercent } from "lucide-react";
import { PLANS, PLAN_FEATURES, waLink } from "@/lib/site";
import { Reveal } from "./Reveal";

const TIER_ICONS = { BASIC: House, ESSENTIAL: Rocket, ULTRA: Trophy };

export default function Plans() {
  return (
    <section id="planos" data-testid="plans-section" className="scroll-mt-24 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.35em] text-violet-400">/ PLANOS</p>
          <h2 className="mt-5 font-display text-4xl font-black tracking-tight sm:text-5xl lg:text-6xl">
            Velocidade de verdade,
            <br className="hidden sm:block" /> preço fixo todo mês.
          </h2>
        </Reveal>

        <div className="mt-14 grid items-stretch gap-6 md:grid-cols-3">
          {PLANS.map((plan, i) => (
            <PlanCard key={plan.tier} plan={plan} i={i} />
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-8 text-sm text-white/40">
            * Consulte disponibilidade na sua rua pelo WhatsApp.
          </p>
        </Reveal>
      </div>
    </section>
  );
}

function PlanCard({ plan, i }) {
  const Icon = TIER_ICONS[plan.tier];
  return (
    <Reveal delay={i * 0.12} className={plan.popular ? "md:-mt-5" : ""}>
      <div
        data-testid={`plan-card-${plan.speed}`}
        className={`relative flex h-full flex-col rounded-2xl border p-8 transition-transform duration-300 hover:-translate-y-1 ${
          plan.popular
            ? "border-violet-600/60 bg-panel shadow-[0_0_80px_-20px_rgba(124,58,237,0.55)]"
            : "border-white/10 bg-surface hover:border-white/25"
        }`}
      >
        {plan.popular && (
          <span className="absolute -top-4 left-8 flex items-center gap-1.5 rounded-full bg-violet-600 px-4 py-1.5 font-mono text-[10px] font-bold tracking-[0.2em] text-white shadow-[0_0_28px_rgba(124,58,237,0.65)]">
            <BadgePercent className="h-3.5 w-3.5" />
            OFERTA · MAIS ESCOLHIDO
          </span>
        )}
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-violet-600/30 bg-violet-600/15">
            <Icon className="h-4 w-4 text-violet-300" />
          </span>
          <p
            className={`font-mono text-xs font-bold tracking-[0.35em] ${
              plan.popular ? "text-violet-300" : "text-white/50"
            }`}
          >
            {plan.tier}
          </p>
        </div>
        <p className="mt-5 font-mono text-6xl font-bold tracking-tighter">
          {plan.speed}
          <span className="ml-2 align-middle font-mono text-sm font-bold tracking-[0.3em] text-violet-400">
            MEGAS
          </span>
        </p>
        <div className="mt-7 flex items-baseline gap-1.5">
          <span className="text-sm text-white/50">R$</span>
          <span className="font-mono text-4xl font-bold">{plan.price}</span>
          <span className="text-sm text-white/50">/mês</span>
        </div>
        <p className="mt-6 text-sm leading-relaxed text-white/60">{plan.rec}</p>
        <ul className="mt-6 flex-1 space-y-3">
          {PLAN_FEATURES.map((f) => (
            <li key={f} className="flex items-start gap-2.5 text-sm text-white/70">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-violet-400" />
              {f}
            </li>
          ))}
        </ul>
        <a
          data-testid={`plan-cta-${plan.speed}`}
          href={waLink(plan.message)}
          target="_blank"
          rel="noopener noreferrer"
          className={`mt-9 rounded-md px-6 py-3.5 text-center text-sm font-medium transition-colors duration-200 ${
            plan.popular
              ? "bg-violet-600 text-white shadow-[0_0_30px_rgba(124,58,237,0.45)] hover:bg-violet-500"
              : "border border-white/10 bg-white/5 text-white hover:bg-white/10"
          }`}
        >
          Assinar {plan.tier}
        </a>
      </div>
    </Reveal>
  );
}
